/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { Tabs, message } from "antd";
import { toast } from "react-toastify";
import { Icon } from "../../components/widgets";
import { create, editRelease } from "../../actions/release";
import { getReleaseTrack } from "../../actions/user";
import ReleaseInfo from "./release-info";
import Price from "./price";
import Territories from "./territories";
import ReleaseDate from "./release-date";
import Promotion from "./promotion";
import TabSelectTrack from "./uploads";
import "react-toastify/dist/ReactToastify.css";

const { TabPane } = Tabs;
const EDIT_RELEASE_PATH = "/release/edit";
const DUPLICATE_RELEASE_PATH = "/release/duplicate";

let initialState: any = {
  releaseInfo: {},
  price: {},
  territories: {},
  releaseDate: {},
  promotion: {},
  discs: [],
};

const setLocalStorageData = (data: any) => {
  localStorage.setItem("discData", JSON.stringify(data));
};

const ReleaseOverview: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [data, setData] = useState<{ [key: string]: any }>({});
  const [callFunction, setCallFunction] = useState<boolean>(false);
  const [clearForm, setClearForm] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [localStorageCleared, setLocalStorageCleared] =
    useState<boolean>(false);
  const [tabValidity, setTabValidity] = useState({
    releaseInfo: true,
    uploadtrack: true,
    price: true,
    territories: true,
    releaseDate: true,
    promotion: true,
  });
  const [releaseId, setReleaseId] = useState<number | undefined>(undefined);

  const handleSubmission = async (name: string, formateData: any) => {
    setData({
      ...data,
      [name]: formateData,
    });
    initialState[name] = formateData;
  };

  const update = async () => {
    if (loading) {
      return;
    }
    setCallFunction(true);
    setLoading(true);

    await new Promise<void>((resolve) =>
      setTimeout(async () => {
        const isValid =
          Object.keys(initialState.releaseInfo).length > 0 &&
          Object.keys(initialState.releaseDate).length > 0 &&
          Object.keys(initialState.price).length > 0 &&
          Object.keys(initialState.territories).length > 0;

        if (!isValid && !releaseId) {
          ["releaseInfo", "releaseDate", "price", "territories"].forEach(
            (tabName) =>
              setTabHandle(
                tabName,
                Object.keys(initialState[tabName]).length > 0
              )
          );
          setLocalStorageData(initialState.discs);
          toast.error("Please fill in all required fields");
        } else if (releaseId) {
          await handleEditRelease();
        } else if (isValid && !releaseId) {
          await handleSubmit();
          initialState = {
            releaseInfo: {},
            price: {},
            territories: {},
            releaseDate: {},
            promotion: {},
            discs: [],
          };
          setLocalStorageCleared(!localStorageCleared);
        }
        setLoading(false);
        resolve();
      }, 2000)
    );
    setCallFunction(false);
  };

  const clearFormDataFromLocalStorage = () => {
    [
      "releaseFormData",
      "releasedate",
      "releasePrice",
      "discData",
      "selectedTerritories",
      "socialMedia",
    ].forEach((item) => localStorage.removeItem(item));
  };

  const handleEditRelease = async () => {
    try {
      await editRelease({
        ...initialState.releaseInfo,
        ...initialState.price,
        ...initialState.releaseDate,
        promotion: initialState.promotion,
        discs: initialState.discs,
        territories: initialState.territories,
        id: releaseId,
      });
      setData(initialState);
      clearFormDataFromLocalStorage();
      toast.success("Release updated successfully");
    } catch (error) {
      console.error("Error during update:", error);
      toast.error("Failed to update release");
    }
  };

  const handleSubmit = async () => {
    try {
      await create({
        ...initialState.releaseInfo,
        ...initialState.price,
        ...initialState.releaseDate,
        promotion: initialState.promotion,
        discs: initialState.discs,
        territories: initialState.territories,
      });
      setData(initialState);
      clearFormDataFromLocalStorage();
      setClearForm(!clearForm);
      toast.success("Release added successfully");
    } catch (error) {
      console.error("Error during add Release:", error);
      toast.error("Failed to add Release!");
    }
  };

  const setTabHandle = (tabName: string, isValid: boolean) => {
    setTabValidity((prev) => ({
      ...prev,
      [tabName]: isValid,
    }));
  };

  const getEditRelease = async (releaseId: number) => {
    const hide = message.loading("Adding Release. Just a sec...", 1000);
    setReleaseId(releaseId);
    await getReleaseDetails(releaseId);
    hide();
    message.success("Success", 3);
  };

  const getDuplicateRelease = async (releaseId: number) => {
    const hide = message.loading("Adding Release. Just a sec...", 1000);
    await getReleaseDetails(releaseId);
    hide();
    message.success("Success", 3);
  };

  const getReleaseDetails = async (id: number) => {
    const getRelease = await getReleaseTrack(id, dispatch);
    if (!getRelease) {
      return;
    }

    initialState.releaseInfo = getRelease;
    initialState.price = getRelease.price;
    initialState.releaseDate = getRelease.releaseDate;
    initialState.territories = getRelease.territories;
    initialState.promotion = getRelease.promotion;
    initialState.discs = getRelease.discs;
  };

  useEffect(() => {
    if (
      location.pathname === EDIT_RELEASE_PATH ||
      location.pathname === DUPLICATE_RELEASE_PATH
    ) {
      dispatch({ type: "SET_EDIT_RELEASE_TRACK", payload: {} });
      const params = new URLSearchParams(window.location.search);
      if (params.size > 0) {
        const editRelease = Number(params.get("id"));
        const uploadRelease = Number(params.get("duplicateId"));
        if (editRelease) {
          getEditRelease(editRelease);
        }
        if (uploadRelease) {
          getDuplicateRelease(uploadRelease)
        }
      }
    }
  }, [window?.location?.search]);

  useEffect(() => {
    if (releaseId && location.pathname !== EDIT_RELEASE_PATH) {
      clearFormDataFromLocalStorage();
      setClearForm(true);
      dispatch({ type: "SET_EDIT_RELEASE_TRACK", payload: {} });
      setReleaseId(undefined);
    }
  }, [location]);

  const operations = (
    <button
      style={{
        background: "#00CBD8",
        padding: "8px 20px",
        borderRadius: "20px",
        color: "white",
        transition: "all 0.1s linear",
        fontStyle: "italic",
        display: "inline-block",
        border: "none",
      }}
      onClick={update}
    >
      {loading ? <Icon name="loading" /> : <i className="fas fa-save">Save</i>}
    </button>
  );

  return (
    <div className="page page-label mb-5 container">
      <div className="w-full px-4 mx-auto px-lg-5 min-h-[80vh]">
        <div className="tw-p-[15px] bg-white rounded-lg mt-8 transition-transform shadow-md relative min-h-[70vh]">
          <div className="table-title relative min-h-14 mt-4">
            <h2 className="mt-4 mx-4 font-thin text-purple-600 text-3xl">
              Release
            </h2>
          </div>

          <Tabs tabBarExtraContent={operations} size="large">
            <TabPane
              tab={
                <div
                  style={{
                    background: tabValidity.releaseInfo ? "" : "#ffcccc",
                    padding: "10px",
                  }}
                  onClick={() => setTabHandle("releaseInfo", true)}
                >
                  Release Info
                </div>
              }
              key="release_info"
              className={`border-none text-uppercase transition-transform duration-100 mx-4 ${
                !tabValidity.releaseInfo ? "tw-color-red-200" : ""
              }`}
            >
              <ReleaseInfo
                handleSubmission={handleSubmission}
                callFunction={callFunction}
                localStorageCleared={localStorageCleared}
                clearForm={clearForm}
              />
            </TabPane>

            <TabPane tab="Upload Track" key="uploadtrack">
              <TabSelectTrack
                handleSubmission={handleSubmission}
                callFunction={callFunction}
                clearForm={clearForm}
              />
            </TabPane>

            <TabPane
              tab={
                <div
                  style={{
                    background: tabValidity.price ? "" : "#ffcccc",
                    padding: "10px",
                  }}
                  onClick={() => setTabHandle("price", true)}
                >
                  Price
                </div>
              }
              key="price"
            >
              <Price
                handleSubmission={handleSubmission}
                callFunction={callFunction}
                localStorageCleared={localStorageCleared}
                clearForm={clearForm}
              />
            </TabPane>

            <TabPane
              tab={
                <div
                  style={{
                    background: tabValidity.territories ? "" : "#ffcccc",
                    padding: "10px",
                  }}
                  onClick={() => setTabHandle("territories", true)}
                >
                  Territories
                </div>
              }
              key="territories"
            >
              <Territories
                handleSubmission={handleSubmission}
                callFunction={callFunction}
                clearForm={clearForm}
              />
            </TabPane>

            <TabPane
              tab={
                <div
                  style={{
                    background: tabValidity.releaseDate ? "" : "#ffcccc",
                    padding: "10px",
                  }}
                  onClick={() => setTabHandle("releaseDate", true)}
                >
                  Release date
                </div>
              }
              key="release_date"
            >
              <ReleaseDate
                handleSubmission={handleSubmission}
                callFunction={callFunction}
                localStorageCleared={localStorageCleared}
                clearForm={clearForm}
              />
            </TabPane>

            <TabPane tab="Promotion" key="promotion">
              <Promotion
                handleSubmission={handleSubmission}
                callFunction={callFunction}
                clearForm={clearForm}
              />
            </TabPane>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default ReleaseOverview;
